import { render, staticRenderFns } from "./SerialNumberConfig.vue?vue&type=template&id=16320103&scoped=true"
import script from "./SerialNumberConfig.vue?vue&type=script&lang=js"
export * from "./SerialNumberConfig.vue?vue&type=script&lang=js"
import style0 from "./SerialNumberConfig.vue?vue&type=style&index=0&id=16320103&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16320103",
  null
  
)

export default component.exports